import gameApp from "@/index";
import { renderThumbnail } from "@/utils/furniture-utils";
import { LitElement, html } from "lit-element";
import { customElement, property } from "lit/decorators.js";

@customElement("furni-viewer")
export class FurniViewer extends LitElement {
  @property({ type: Boolean }) open = false;
  @property({ type: Number }) id: any = null;
  @property({ type: String }) thumbnailUrl = "";
  name: string;

  constructor() {
    super();
  }

  protected createRenderRoot() {
    return this;
  }

  openView() {
    this.open = true;
  }

  closeView() {
    this.open = false;
  }

  get hasModeratingPermission() {
    // const currentScene = GameApp.game.currentScene as Location;
    // const ownerId = currentScene?.ownerId;

    // const authenticatedUserId = parseInt(
    //   localStorage.getItem("tam_user_id"),
    //   10
    // );

    return true;
  }

  async modify(properties: {
    id?: number;
    name?: string;
    furnitureResource?: any;
  }) {
    if (properties.id !== undefined) {
      this.id = properties.id;
    }

    if (properties.name !== undefined) {
      this.name = properties.name;
    }

    if (properties.furnitureResource !== undefined) {
      this.thumbnailUrl = await renderThumbnail(properties.furnitureResource);
    }
  }

  handleUse() {
    gameApp.wsClient.sendMessage(
      JSON.stringify({
        action: "furniture_actions",
        arguments: {
          action: "set_state",
          id: this.id,
        },
      })
    );
  }

  handleMove() {
    this.dispatchEvent(
      new CustomEvent("furni-move", {
        detail: { id: this.id },
        bubbles: true,
        composed: true,
      })
    );
  }

  handleRotate() {
    this.dispatchEvent(
      new CustomEvent("furni-rotate", {
        detail: { id: this.id },
        bubbles: true,
        composed: true,
      })
    );
  }

  handleDelete() {
    this.dispatchEvent(
      new CustomEvent("furni-delete", {
        detail: { id: this.id },
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    return html`
      <div class="furni_viewer ${this.open ? "open" : ""}">
        <button
          class=" furni_viewer__close"
          @click=${() => (this.open = false)}
        >
          <span>Close</span>
        </button>

        <h1 class="furni_viewer__title">${this.name}</h1>
        <img src=${this.thumbnailUrl} alt=${this.name} />
        <div class="furni_viewer__button-group">
          <button class="btn" @click=${this.handleUse}>Use</button>

          ${this.hasModeratingPermission
            ? html`
                <button class="btn" @click=${this.handleMove}>Move</button>
                <button class="btn" @click=${this.handleRotate}>Rotate</button>
                <button class="btn" @click=${this.handleDelete}>Pickup</button>
              `
            : ""}
        </div>
      </div>
    `;
  }
}
